export const toSentenceCase = (sentence: string): string => {
  if (!sentence) return '';
  const [first, ...rest] = sentence;
  return `${first.toUpperCase()}${rest.join('')}`;
};

export const snakeCaseToWhiteSpace = (snakeCased: string): string => {
  if (!snakeCased) return '';
  return snakeCased.replace(/_/g, ' ');
};

export const enumToDisplay = (string: string) => {
  return toSentenceCase(snakeCaseToWhiteSpace(string));
};
